// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/loginPageBckground.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center / cover no-repeat fixed;
  padding: 20px;
  position: relative;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 0;
}

.login-container>* {
  position: relative;
  z-index: 1;
}

.back-to-home {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  padding: 0.6rem 1.2rem;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(30, 64, 175, 0.4);
  transition: all 0.3s ease;
  z-index: 1;
  margin-top: 1rem;
}

.back-to-home:hover {
  background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.55);
}

.login-card {
  width: 100%;
  max-width: 900px;
  min-height: 560px;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  background-color: white;
  overflow: hidden;
  display: flex;
  animation: slideUp 0.5s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Left Side - Branding */
.login-left {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 2.5rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  color: #1e293b;
  text-align: center;
  position: relative;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}

.login-left::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.15) 100%);
  z-index: 0;
}

.login-left .logo-container-login {
  position: relative;
  z-index: 1;
  margin-bottom: 1.5rem;
}

.login-left .logo-image {
  width: 140px;
  height: 140px;
  object-fit: contain;
  filter: drop-shadow(0 8px 24px rgba(0, 0, 0, 0.2));
  animation: fadeIn 0.6s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.login-left .login-title {
  color: #1e293b;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 1;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
}

.login-left .login-subtitle {
  color: #475569;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  font-weight: 400;
  position: relative;
  z-index: 1;
}

.download-app-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  color: white;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.6rem 1.2rem;
  border-radius: 10px;
  text-decoration: none;
  position: relative;
  z-index: 1;
  box-shadow: 0 4px 14px rgba(30, 64, 175, 0.35);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.download-app-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.45);
  background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%);
}

.download-app-btn .play-icon {
  width: 18px;
  height: 18px;
}

/* Right Side - Form */
.login-right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2.5rem 3rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e0e7ff 100%);
  overflow-y: auto;
}

.login-right-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.login-right-header h3 {
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.login-right-header p {
  color: #64748b;
  font-size: 0.9rem;
}

/* Auth Tabs - Login/Sign Up Toggle */
.auth-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding: 4px;
  background-color: #f1f5f9;
  border-radius: 12px;
}

.auth-tab {
  flex: 1 1;
  padding: 0.625rem;
  border: none;
  border-radius: 10px;
  background-color: transparent;
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.auth-tab:hover {
  color: #3b82f6;
}

.auth-tab.active {
  background-color: white;
  color: #1e40af;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Input Groups */
.input-group {
  position: relative;
  margin-bottom: 1rem;
}

.input-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #3b82f6;
  font-size: 1rem;
  z-index: 1;
}

.input-group input {
  width: 100%;
  padding: 0.875rem 3rem 0.875rem 3rem;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  font-size: 0.95rem;
  outline: none;
  transition: all 0.3s ease;
  background-color: #f8fafc;
  color: #1e293b;
}

.input-group input:focus {
  border-color: #3b82f6;
  background-color: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.input-group input::placeholder {
  color: #94a3b8;
}

.input-group input[type="password"],
.input-group input[type="text"] {
  padding-right: 3rem;
}

/* Password Toggle Button */
.password-toggle {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.password-toggle:hover {
  color: #64748b;
}

/* Login Method Toggle - OTP/Password */
.login-method-label {
  text-align: left;
  font-size: 0.7rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}

.login-method-toggle {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.method-btn {
  flex: 1 1;
  padding: 0.625rem 0.75rem;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  background-color: white;
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
}

.method-btn:hover:not(:disabled) {
  border-color: #3b82f6;
  color: #3b82f6;
  background-color: #eff6ff;
}

.method-btn.active {
  border-color: #1e40af;
  color: #1e40af;
  background-color: #eff6ff;
  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.1);
}

.method-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Login Button */
.login-button {
  width: 100%;
  padding: 0.875rem;
  background-color: #1e3a8a;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.25);
  margin-top: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.login-button:hover:not(:disabled) {
  background-color: #1e40af;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.3);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
  box-shadow: none;
}

.login-button.signup-button {
  background-color: #1e3a8a;
}

/* OTP Form */
.otp-form {
  animation: fadeIn 0.3s ease-out;
}

/* Messages */
.error-message {
  background-color: #fef2f2;
  color: #dc2626;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  margin-bottom: 1.25rem;
  text-align: left;
  border-left: 3px solid #ef4444;
  font-size: 0.9rem;
  animation: shake 0.4s ease-in-out;
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  75% {
    transform: translateX(5px);
  }
}

.info-message {
  background-color: #eff6ff;
  color: #1d4ed8;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  margin-bottom: 1.25rem;
  text-align: left;
  border-left: 3px solid #3b82f6;
  font-size: 0.9rem;
}

/* Secondary Button */
.secondary-button {
  width: 100%;
  padding: 0.75rem;
  background-color: transparent;
  color: #475569;
  border: 1.5px solid #cbd5e1;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 0.75rem;
}

.secondary-button:hover:not(:disabled) {
  background-color: #f1f5f9;
  border-color: #94a3b8;
}

.secondary-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Form Transition */
form {
  animation: fadeIn 0.3s ease-out;
}

/* Responsive Design - Tablet */
@media (max-width: 768px) {
  .login-card {
    flex-direction: column;
    max-width: 480px;
    min-height: auto;
  }

  .login-left {
    padding: 2rem 1.5rem;
    flex: none;
  }

  .login-left .logo-image {
    width: 80px;
    height: 80px;
  }

  .login-left .login-title {
    font-size: 1.5rem;
  }

  .login-left .login-subtitle {
    font-size: 0.9rem;
  }

  .login-right {
    padding: 2rem 1.5rem;
    flex: none;
  }

  .login-right-header {
    margin-bottom: 1.25rem;
  }

  .login-right-header h3 {
    font-size: 1.3rem;
  }
}

/* Responsive Design - Mobile */
@media (max-width: 480px) {
  .login-container {
    padding: 0;
    align-items: flex-start;
    min-height: 100vh;
  }

  .back-to-home {
    padding: 0.4rem 0.9rem;
    font-size: 0.75rem;
    border-radius: 8px;
    gap: 0.3rem;
    margin-top: 0.5rem;
  }

  .login-card {
    border-radius: 0;
    min-height: 100vh;
    max-width: 100%;
    box-shadow: none;
    flex-direction: column;
  }

  .login-left {
    padding: 1rem 1rem 0.75rem;
    flex: none;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  .login-left .logo-container-login {
    margin-bottom: 0.5rem;
  }

  .login-left .logo-image {
    width: 50px;
    height: 50px;
  }

  .login-left .login-title {
    font-size: 1.1rem;
    margin-bottom: 0.25rem;
  }

  .login-left .login-subtitle {
    font-size: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .download-app-btn {
    padding: 0.4rem 0.9rem;
    font-size: 0.75rem;
    margin-bottom: 0.5rem;
  }

  .download-app-btn .play-icon {
    width: 14px;
    height: 14px;
  }

  .login-right {
    padding: 1rem 1rem 0.5rem;
    flex: 1 1;
    justify-content: flex-start;
  }

  .login-right-header {
    margin-bottom: 0.75rem;
  }

  .login-right-header h3 {
    font-size: 1.1rem;
  }

  .login-right-header p {
    font-size: 0.8rem;
  }

  .auth-tabs {
    margin-bottom: 0.75rem;
  }

  .auth-tab {
    font-size: 0.85rem;
    padding: 0.4rem;
  }

  .input-group {
    margin-bottom: 0.6rem;
  }

  .input-group input {
    padding: 0.6rem 0.75rem 0.6rem 2.5rem;
    font-size: 0.9rem;
  }

  .input-icon {
    left: 0.75rem;
    font-size: 0.9rem;
  }

  .login-method-label {
    font-size: 0.65rem;
    margin-bottom: 0.4rem;
  }

  .login-method-toggle {
    margin-bottom: 0.6rem;
  }

  .method-btn {
    font-size: 0.8rem;
    padding: 0.4rem;
  }

  .login-button {
    padding: 0.65rem;
    font-size: 0.9rem;
    margin-top: 0.5rem;
  }

  .secondary-button {
    padding: 0.5rem;
    font-size: 0.85rem;
  }

  .password-toggle {
    right: 0.6rem;
    font-size: 0.9rem;
  }
}

.laptop-top-home-btn {
  display: none; /* Hidden by default on mobile/tablet */
}

@media (min-width: 1024px) {
  .laptop-top-home-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 24px;
    left: 24px;
    width: 48px;
    height: 48px;
    background-color: white;
    color: #1e3a8a;
    border-radius: 50%;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    z-index: 10;
    text-decoration: none;
    font-size: 1.25rem;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .laptop-top-home-btn:hover {
    transform: translateX(-4px) scale(1.05);
    background-color: #f8fafc;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    color: #2563eb;
  }
}

.login-lang-selector {
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 10;
}

.lang-select-dropdown {
  padding: 8px 16px;
  background-color: white;
  color: #1e3a8a;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
}

.lang-select-dropdown:hover {
  background-color: #f8fafc;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .login-lang-selector {
    top: 16px;
    right: 16px;
  }
  .lang-select-dropdown {
    padding: 6px 12px;
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yFAAuF;EACvF,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,6DAA6D;EAC7D,mBAAmB;EACnB,0CAA0C;EAC1C,6CAA6C;EAC7C,yBAAyB;EACzB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gGAAgG;EAChG,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,8CAA8C;EAC9C,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,0EAA0E;EAC1E,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;AACjC;;AAEA,+BAA+B;AAC/B;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,UAAU;IACV,kBAAkB;IAClB,iDAAiD;EACnD;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,SAAO;IACP,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;IACrC,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa,EAAE,uCAAuC;AACxD;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,uCAAuC;IACvC,yBAAyB;IACzB,yCAAyC;IACzC,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":[".login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: url('/public/loginPageBckground.png') center center / cover no-repeat fixed;\n  padding: 20px;\n  position: relative;\n}\n\n.login-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.25);\n  z-index: 0;\n}\n\n.login-container>* {\n  position: relative;\n  z-index: 1;\n}\n\n.back-to-home {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: white;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-decoration: none;\n  padding: 0.6rem 1.2rem;\n  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  box-shadow: 0 4px 15px rgba(30, 64, 175, 0.4);\n  transition: all 0.3s ease;\n  z-index: 1;\n  margin-top: 1rem;\n}\n\n.back-to-home:hover {\n  background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.55);\n}\n\n.login-card {\n  width: 100%;\n  max-width: 900px;\n  min-height: 560px;\n  border-radius: 24px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  background-color: white;\n  overflow: hidden;\n  display: flex;\n  animation: slideUp 0.5s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Left Side - Branding */\n.login-left {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 3rem 2.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  color: #1e293b;\n  text-align: center;\n  position: relative;\n  border-right: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.login-left::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.15) 100%);\n  z-index: 0;\n}\n\n.login-left .logo-container-login {\n  position: relative;\n  z-index: 1;\n  margin-bottom: 1.5rem;\n}\n\n.login-left .logo-image {\n  width: 140px;\n  height: 140px;\n  object-fit: contain;\n  filter: drop-shadow(0 8px 24px rgba(0, 0, 0, 0.2));\n  animation: fadeIn 0.6s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.login-left .login-title {\n  color: #1e293b;\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  position: relative;\n  z-index: 1;\n  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);\n}\n\n.login-left .login-subtitle {\n  color: #475569;\n  font-size: 1rem;\n  margin-bottom: 1.5rem;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n}\n\n.download-app-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);\n  color: white;\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.6rem 1.2rem;\n  border-radius: 10px;\n  text-decoration: none;\n  position: relative;\n  z-index: 1;\n  box-shadow: 0 4px 14px rgba(30, 64, 175, 0.35);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.download-app-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.45);\n  background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%);\n}\n\n.download-app-btn .play-icon {\n  width: 18px;\n  height: 18px;\n}\n\n/* Right Side - Form */\n.login-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 2.5rem 3rem;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e0e7ff 100%);\n  overflow-y: auto;\n}\n\n.login-right-header {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.login-right-header h3 {\n  color: #1e293b;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n}\n\n.login-right-header p {\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n/* Auth Tabs - Login/Sign Up Toggle */\n.auth-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  padding: 4px;\n  background-color: #f1f5f9;\n  border-radius: 12px;\n}\n\n.auth-tab {\n  flex: 1;\n  padding: 0.625rem;\n  border: none;\n  border-radius: 10px;\n  background-color: transparent;\n  color: #64748b;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.auth-tab:hover {\n  color: #3b82f6;\n}\n\n.auth-tab.active {\n  background-color: white;\n  color: #1e40af;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n/* Input Groups */\n.input-group {\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.input-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #3b82f6;\n  font-size: 1rem;\n  z-index: 1;\n}\n\n.input-group input {\n  width: 100%;\n  padding: 0.875rem 3rem 0.875rem 3rem;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  outline: none;\n  transition: all 0.3s ease;\n  background-color: #f8fafc;\n  color: #1e293b;\n}\n\n.input-group input:focus {\n  border-color: #3b82f6;\n  background-color: white;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n}\n\n.input-group input::placeholder {\n  color: #94a3b8;\n}\n\n.input-group input[type=\"password\"],\n.input-group input[type=\"text\"] {\n  padding-right: 3rem;\n}\n\n/* Password Toggle Button */\n.password-toggle {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 1rem;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s ease;\n}\n\n.password-toggle:hover {\n  color: #64748b;\n}\n\n/* Login Method Toggle - OTP/Password */\n.login-method-label {\n  text-align: left;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.login-method-toggle {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.method-btn {\n  flex: 1;\n  padding: 0.625rem 0.75rem;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  background-color: white;\n  color: #64748b;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n}\n\n.method-btn:hover:not(:disabled) {\n  border-color: #3b82f6;\n  color: #3b82f6;\n  background-color: #eff6ff;\n}\n\n.method-btn.active {\n  border-color: #1e40af;\n  color: #1e40af;\n  background-color: #eff6ff;\n  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.1);\n}\n\n.method-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Login Button */\n.login-button {\n  width: 100%;\n  padding: 0.875rem;\n  background-color: #1e3a8a;\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.25);\n  margin-top: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.login-button:hover:not(:disabled) {\n  background-color: #1e40af;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.3);\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-button:disabled {\n  background: #cbd5e1;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.login-button.signup-button {\n  background-color: #1e3a8a;\n}\n\n/* OTP Form */\n.otp-form {\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Messages */\n.error-message {\n  background-color: #fef2f2;\n  color: #dc2626;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  margin-bottom: 1.25rem;\n  text-align: left;\n  border-left: 3px solid #ef4444;\n  font-size: 0.9rem;\n  animation: shake 0.4s ease-in-out;\n}\n\n@keyframes shake {\n\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n\n  25% {\n    transform: translateX(-5px);\n  }\n\n  75% {\n    transform: translateX(5px);\n  }\n}\n\n.info-message {\n  background-color: #eff6ff;\n  color: #1d4ed8;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  margin-bottom: 1.25rem;\n  text-align: left;\n  border-left: 3px solid #3b82f6;\n  font-size: 0.9rem;\n}\n\n/* Secondary Button */\n.secondary-button {\n  width: 100%;\n  padding: 0.75rem;\n  background-color: transparent;\n  color: #475569;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 0.75rem;\n}\n\n.secondary-button:hover:not(:disabled) {\n  background-color: #f1f5f9;\n  border-color: #94a3b8;\n}\n\n.secondary-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Form Transition */\nform {\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Responsive Design - Tablet */\n@media (max-width: 768px) {\n  .login-card {\n    flex-direction: column;\n    max-width: 480px;\n    min-height: auto;\n  }\n\n  .login-left {\n    padding: 2rem 1.5rem;\n    flex: none;\n  }\n\n  .login-left .logo-image {\n    width: 80px;\n    height: 80px;\n  }\n\n  .login-left .login-title {\n    font-size: 1.5rem;\n  }\n\n  .login-left .login-subtitle {\n    font-size: 0.9rem;\n  }\n\n  .login-right {\n    padding: 2rem 1.5rem;\n    flex: none;\n  }\n\n  .login-right-header {\n    margin-bottom: 1.25rem;\n  }\n\n  .login-right-header h3 {\n    font-size: 1.3rem;\n  }\n}\n\n/* Responsive Design - Mobile */\n@media (max-width: 480px) {\n  .login-container {\n    padding: 0;\n    align-items: flex-start;\n    min-height: 100vh;\n  }\n\n  .back-to-home {\n    padding: 0.4rem 0.9rem;\n    font-size: 0.75rem;\n    border-radius: 8px;\n    gap: 0.3rem;\n    margin-top: 0.5rem;\n  }\n\n  .login-card {\n    border-radius: 0;\n    min-height: 100vh;\n    max-width: 100%;\n    box-shadow: none;\n    flex-direction: column;\n  }\n\n  .login-left {\n    padding: 1rem 1rem 0.75rem;\n    flex: none;\n    border-right: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  }\n\n  .login-left .logo-container-login {\n    margin-bottom: 0.5rem;\n  }\n\n  .login-left .logo-image {\n    width: 50px;\n    height: 50px;\n  }\n\n  .login-left .login-title {\n    font-size: 1.1rem;\n    margin-bottom: 0.25rem;\n  }\n\n  .login-left .login-subtitle {\n    font-size: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .download-app-btn {\n    padding: 0.4rem 0.9rem;\n    font-size: 0.75rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .download-app-btn .play-icon {\n    width: 14px;\n    height: 14px;\n  }\n\n  .login-right {\n    padding: 1rem 1rem 0.5rem;\n    flex: 1;\n    justify-content: flex-start;\n  }\n\n  .login-right-header {\n    margin-bottom: 0.75rem;\n  }\n\n  .login-right-header h3 {\n    font-size: 1.1rem;\n  }\n\n  .login-right-header p {\n    font-size: 0.8rem;\n  }\n\n  .auth-tabs {\n    margin-bottom: 0.75rem;\n  }\n\n  .auth-tab {\n    font-size: 0.85rem;\n    padding: 0.4rem;\n  }\n\n  .input-group {\n    margin-bottom: 0.6rem;\n  }\n\n  .input-group input {\n    padding: 0.6rem 0.75rem 0.6rem 2.5rem;\n    font-size: 0.9rem;\n  }\n\n  .input-icon {\n    left: 0.75rem;\n    font-size: 0.9rem;\n  }\n\n  .login-method-label {\n    font-size: 0.65rem;\n    margin-bottom: 0.4rem;\n  }\n\n  .login-method-toggle {\n    margin-bottom: 0.6rem;\n  }\n\n  .method-btn {\n    font-size: 0.8rem;\n    padding: 0.4rem;\n  }\n\n  .login-button {\n    padding: 0.65rem;\n    font-size: 0.9rem;\n    margin-top: 0.5rem;\n  }\n\n  .secondary-button {\n    padding: 0.5rem;\n    font-size: 0.85rem;\n  }\n\n  .password-toggle {\n    right: 0.6rem;\n    font-size: 0.9rem;\n  }\n}\n\n.laptop-top-home-btn {\n  display: none; /* Hidden by default on mobile/tablet */\n}\n\n@media (min-width: 1024px) {\n  .laptop-top-home-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 24px;\n    left: 24px;\n    width: 48px;\n    height: 48px;\n    background-color: white;\n    color: #1e3a8a;\n    border-radius: 50%;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n    transition: all 0.3s ease;\n    z-index: 10;\n    text-decoration: none;\n    font-size: 1.25rem;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n  }\n\n  .laptop-top-home-btn:hover {\n    transform: translateX(-4px) scale(1.05);\n    background-color: #f8fafc;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n    color: #2563eb;\n  }\n}\n\n.login-lang-selector {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  z-index: 10;\n}\n\n.lang-select-dropdown {\n  padding: 8px 16px;\n  background-color: white;\n  color: #1e3a8a;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.lang-select-dropdown:hover {\n  background-color: #f8fafc;\n  border-color: rgba(0, 0, 0, 0.15);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);\n}\n\n@media (max-width: 768px) {\n  .login-lang-selector {\n    top: 16px;\n    right: 16px;\n  }\n  .lang-select-dropdown {\n    padding: 6px 12px;\n    font-size: 0.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
